/**
 * Phase 1 - small constant tables for question categorization.
 */

export const QUESTION_CATEGORIES = [
  { value: 'CODING',           label: 'Coding' },
  { value: 'SYSTEM_DESIGN',    label: 'System Design' },
  { value: 'BEHAVIORAL',       label: 'Behavioral' },
  { value: 'DOMAIN_KNOWLEDGE', label: 'Domain Knowledge' },
  { value: 'DEBUGGING',        label: 'Debugging' },
  { value: 'OTHER',            label: 'Other' },
];

export const QUESTION_DIFFICULTIES = [
  { value: 'EASY',   label: 'Easy',   tone: 'success' },
  { value: 'MEDIUM', label: 'Medium', tone: 'warning' },
  { value: 'HARD',   label: 'Hard',   tone: 'danger'  },
];

export function categoryLabel(value) {
  return QUESTION_CATEGORIES.find((c) => c.value === value)?.label || value;
}

export function difficultyMeta(value) {
  return QUESTION_DIFFICULTIES.find((d) => d.value === value) || { label: value, tone: 'neutral' };
}
